<ng-container data-test-filters *ngIf="showFlightSelectionFilters">
  <fcom-carousel
    *ngIf="(isMobile$ | async) === false"
    class="block overflow-auto"
    [leftIcon]="'arrow-left-outline'"
    [rightIcon]="'arrow-right-outline'"
    [whiteIcon]="true"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    [contentChanged$]="resizedWatcher$"
  >
    <div
      data-test-desktop-filters
      class="flex nowrap flex--middle flex--nowrap ps-xxsmall-x ps-xxsmall-t ps-small-b ms-xxsmall-b"
    >
      <!--DIRECT FILTER-->
      <fcom-filters
        data-test-stops-filter
        *ngIf="showStopsFilter$ | async"
        class="ms-small-r"
        [isMobile$]="isMobile$"
        [hasFiltering]="selectedStopsOption !== null"
        [headerText]="'flightFilters.stopsCount.title' | finLocalization"
        [buttonText]="'flightFilters.stopsCount.title' | finLocalization"
        [buttonTextWhenFiltered]="
          selectedStopsOption === 1
            ? ('flightFilters.stopsCount.title' | finLocalization)
            : ('flightFilters.stopsCount.directFlight' | finLocalization)
        "
        [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
        [secondaryFooterButtonTitle]="'flightFilters.action.clear' | finLocalization"
        (primaryFooterButtonClick)="closeTooltip()"
        (secondaryFooterButtonClick)="clearFilter('stopsCount')"
        (tooltipOpeningClick)="sendAnalytics('stops')"
      >
        <div tooltip-content class="ps-medium-x ps-large-b">
          <fin-input-radio
            *ngFor="
              let option of [
                { label: 'all', value: null },
                { label: 'stops', value: 1 },
                { label: 'direct', value: 0 }
              ]
            "
            [name]="option.label"
            (radioChange)="onSelectStopsCount(option.value)"
            [value]="option.label"
            [selected]="selectedStopsOption === option.value"
            [label]="'flightFilters.stopsCount.' + option.label | finLocalization"
          >
          </fin-input-radio>
        </div>
      </fcom-filters>

      <!-- TRAVEL CLASS FILTER-->
      <fcom-filters
        *ngIf="selectedTravelClass"
        class="ms-small-r"
        [isMobile$]="isMobile$"
        [hasFiltering]="selectedTravelClass !== Cabin.MIXED"
        [disabled]="shouldNotClearTravelClass"
        [headerText]="'flightFilters.travelClass.title' | finLocalization"
        [buttonText]="'flightFilters.travelClass.title' | finLocalization"
        [buttonTextWhenFiltered]="
          selectedTravelClass === Cabin.MIXED
            ? ('flightFilters.travelClass.title' | finLocalization)
            : ('travelClass.' + (selectedTravelClass | lowercase) + 'Class' | finLocalization)
        "
        [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
        [secondaryFooterButtonTitle]="'flightFilters.action.clear' | finLocalization"
        (primaryFooterButtonClick)="closeTooltip()"
        (secondaryFooterButtonClick)="clearFilter('cabin')"
        (tooltipOpeningClick)="sendAnalytics('travel-class')"
      >
        <div tooltip-content class="ps-medium-x ps-large-b">
          <fin-input-radio
            *ngFor="let option of travelClasses$ | async; let i = index"
            [name]="option"
            [disabled]="isTravelClassChoicesDisabled"
            (radioChange)="onSelectTravelClass(option)"
            [value]="option"
            [selected]="selectedTravelClass === option"
            [label]="'travelClass.' + (option | lowercase) | finLocalization"
          >
          </fin-input-radio>
        </div>
      </fcom-filters>

      <!-- REFUNDABILITY FILTER-->
      <fcom-filters
        *ngIf="showRefundability"
        class="ms-small-r"
        [isMobile$]="isMobile$"
        [hasFiltering]="selectedRefundabilityOption !== false"
        [headerText]="'flightFilters.refundability.title' | finLocalization"
        [buttonText]="'flightFilters.refundability.title' | finLocalization"
        [buttonTextWhenFiltered]="
          selectedRefundabilityOption === false
            ? ('flightFilters.refundability.title' | finLocalization)
            : ('flightFilters.refundability.refundableTicket' | finLocalization)
        "
        [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
        [secondaryFooterButtonTitle]="'flightFilters.action.clear' | finLocalization"
        (primaryFooterButtonClick)="closeTooltip()"
        (secondaryFooterButtonClick)="clearFilter('refundable')"
        (tooltipOpeningClick)="sendAnalytics('refundability')"
      >
        <div tooltip-content class="ps-medium-x ps-large-b">
          <fin-input-radio
            *ngFor="
              let option of [
                { label: 'anyTicketType', value: false },
                { label: 'onlyRefundable', value: true }
              ]
            "
            [name]="option.label"
            (radioChange)="onSelectRefundability(option.value)"
            [value]="option.label"
            [selected]="selectedRefundabilityOption === option.value"
            [label]="'flightFilters.refundability.' + option.label | finLocalization"
          >
          </fin-input-radio>
        </div>
      </fcom-filters>

      <!-- Times filter  -->
      <fcom-filters
        [isMobile$]="isMobile$"
        [hasFiltering]="selectedDepartureTimes?.length < 3 || selectedArrivalTimes?.length < 3"
        [headerText]="'flightFilters.times.title' | finLocalization"
        [buttonText]="'flightFilters.times.title' | finLocalization"
        [buttonTextWhenFiltered]="'flightFilters.times.title' | finLocalization"
        [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
        [secondaryFooterButtonTitle]="'flightFilters.action.clear' | finLocalization"
        (primaryFooterButtonClick)="closeTooltip()"
        (secondaryFooterButtonClick)="
          activeTab$.getValue() === 0 ? clearFilter('departureTime') : clearFilter('arrivalTime')
        "
        (tooltipOpeningClick)="sendAnalytics('times')"
      >
        <div tooltip-content class="ps-medium-x flex flex--column">
          <fcom-tabs
            (clickedTab)="setActiveTimesTab($event)"
            [theme]="TabTheme.DEFAULT"
            [prevButtonAriaLabel]="'previous'"
            [nextButtonAriaLabel]="'next'"
          >
            <fcom-tab [title]="'flightFilters.times.departure.title' | finLocalization">
              <span data-test-departure-from class="font-body-1">
                {{ 'flightFilters.times.departure.from' | finLocalization }}
                <b>{{ departureCityName }}</b>
              </span>

              <div class="flex flex--column ms-medium-t">
                <ng-container *ngFor="let departureTime of FlightTimeOption | keyvalue: keepOrder">
                  <fcom-checkbox
                    class="ms-small-b"
                    [id]="departureTime.key"
                    [name]="departureTime.key.toLowerCase()"
                    [checked]="selectedDepartureTimes?.includes(departureTime.value)"
                    (change)="onSelectDepartureTime(departureTime.value)"
                  >
                    <div class="flex flex--column">
                      <span class="font-body-1 medium-type">
                        {{ 'flightFilters.times.departure.' + departureTime.key.toLowerCase() | finLocalization }}
                      </span>
                      <span class="font-body-2 light-type ms-xxsmall-t">{{ getTimeRange(departureTime.value) }}</span>
                    </div>
                  </fcom-checkbox>
                </ng-container>
              </div>
            </fcom-tab>
            <fcom-tab [title]="'flightFilters.times.arrival.title' | finLocalization">
              <span data-test-arriving-in class="font-body-1">
                {{ 'flightFilters.times.arrival.landing' | finLocalization }}
                <b>{{ arrivalCityName }}</b></span
              >
              <div class="flex flex--column ms-medium-t">
                <ng-container *ngFor="let arrivalTime of FlightTimeOption | keyvalue: keepOrder">
                  <fcom-checkbox
                    class="ms-small-b"
                    [id]="arrivalTime.key"
                    [name]="arrivalTime.key.toLowerCase()"
                    [checked]="selectedArrivalTimes?.includes(arrivalTime.value)"
                    (change)="onSelectArrivalTime(arrivalTime.value)"
                  >
                    <div class="flex flex--column">
                      <span class="font-body-1 medium-type">
                        {{ 'flightFilters.times.arrival.' + arrivalTime.key.toLowerCase() | finLocalization }}
                      </span>
                      <span class="font-body-2 light-type ms-xxsmall-t">{{ getTimeRange(arrivalTime.value) }}</span>
                    </div>
                  </fcom-checkbox>
                </ng-container>
              </div>
            </fcom-tab>
          </fcom-tabs>
        </div>
      </fcom-filters>

      <!-- Clear all filters -->
      <fcom-button
        *ngIf="showClearAllBtn"
        [theme]="ButtonTheme.TERTIARY"
        [icon]="{ category: 'svg-library', name: 'trash', position: IconPosition.LEFT }"
        [text]="'flightFilters.clearAll' | finLocalization"
        (click)="clearAllFilters('desktop')"
        class="ms-small-l"
        data-test-clear-all-filters
      ></fcom-button>
    </div>
  </fcom-carousel>

  <ng-container *ngIf="isMobile$ | async">
    <fcom-filters
      *ngIf="travelClasses$ | async as availableCabinClasses"
      data-test-mobile-filters
      [isMobile$]="isMobile$"
      [isModalOpen]="isModalOpen"
      [hasFiltering]="(selectedFiltersLength$ | async) > 0"
      [buttonText]="'flightFilters.title' | finLocalization"
      [modalTitle]="'flightFilters.modalTitle' | finLocalization"
      [notificationContent]="'flightFilters.modalNotification' | finLocalization"
      [numberToShowWhenFiltered]="selectedFiltersLength$ | async"
      [dispayNotification]="resultsAmount === 0"
      [primaryFooterButtonTitle]="'flightFilters.action.showResults' | finLocalization: { flights: resultsAmount }"
      (primaryFooterButtonClick)="closeModal()"
      [secondaryFooterButtonTitle]="'flightFilters.action.clear' | finLocalization"
      (secondaryFooterButtonClick)="clearAllFilters('mobile')"
      (showModal)="showModal()"
      (closeModal)="closeModal()"
    >
      <ng-container modal-content>
        <div class="ms-large ps-large-b border-bottom">
          <span class="nordic-blue-900-text font-body-1 medium type">{{
            'flightFilters.stopsCount.title' | finLocalization
          }}</span>
          <fin-input-radio
            *ngFor="
              let option of [
                { label: 'all', value: null },
                { label: 'stops', value: 1 },
                { label: 'direct', value: 0 }
              ]
            "
            [name]="option.label"
            (radioChange)="onSelectStopsCount(option.value)"
            [value]="option.label"
            [selected]="selectedStopsOption === option.value"
            [label]="'flightFilters.stopsCount.' + option.label | finLocalization"
          >
          </fin-input-radio>
        </div>

        <div class="ms-large ps-large-b border-bottom">
          <span class="nordic-blue-900-text font-body-1 medium-type">{{
            'flightFilters.travelClass.title' | finLocalization
          }}</span>
          <fin-input-radio
            *ngFor="let option of availableCabinClasses; let i = index"
            [name]="option"
            (radioChange)="onSelectTravelClass(option)"
            [value]="option"
            [disabled]="shouldNotClearTravelClass"
            [selected]="selectedTravelClass === option"
            [label]="'travelClass.' + (option | lowercase) + 'Class' | finLocalization"
          >
          </fin-input-radio>
        </div>

        <div class="ms-large border-bottom">
          <div class="flex flex--column">
            <span class="nordic-blue-900-text font-body-1 medium-type ps-xsmall-b">{{
              'flightFilters.times.departure.title' | finLocalization
            }}</span>
            <span class="font-body-1">
              {{ 'flightFilters.times.departure.from' | finLocalization }}
              <b>{{ departureCityName }}</b>
            </span>
          </div>

          <div class="flex flex--column ms-medium-t">
            <ng-container *ngFor="let departureTime of FlightTimeOption | keyvalue: keepOrder">
              <fcom-checkbox
                class="ms-large-b"
                [id]="departureTime.key"
                [name]="departureTime.key.toLowerCase()"
                [checked]="selectedDepartureTimes?.includes(departureTime.value)"
                (change)="onSelectDepartureTime(departureTime.value)"
              >
                <div class="flex flex--column">
                  <span class="font-body-1 medium-type">
                    {{ 'flightFilters.times.departure.' + departureTime.key.toLowerCase() | finLocalization }}
                  </span>
                  <span class="font-body-1 light-type ms-xxsmall-t">{{ getTimeRange(departureTime.value) }}</span>
                </div>
              </fcom-checkbox>
            </ng-container>
          </div>
        </div>

        <div class="ms-large border-bottom">
          <div class="flex flex--column">
            <span class="nordic-blue-900-text font-body-1 medium-type ps-xsmall-b">{{
              'flightFilters.times.arrival.title' | finLocalization
            }}</span>
            <span class="font-body-1">
              {{ 'flightFilters.times.arrival.landing' | finLocalization }}
              <b>{{ arrivalCityName }}</b></span
            >
          </div>
          <div class="flex flex--column ms-medium-t">
            <ng-container *ngFor="let arrivalTime of FlightTimeOption | keyvalue: keepOrder">
              <fcom-checkbox
                class="ms-large-b"
                [id]="arrivalTime.key"
                [name]="arrivalTime.key.toLowerCase()"
                [checked]="selectedArrivalTimes?.includes(arrivalTime.value)"
                (change)="onSelectArrivalTime(arrivalTime.value)"
              >
                <div class="flex flex--column">
                  <span class="font-body-1 medium-type">
                    {{ 'flightFilters.times.arrival.' + arrivalTime.key.toLowerCase() | finLocalization }}
                  </span>
                  <span class="font-body-2 light-type ms-xxsmall-t">{{ getTimeRange(arrivalTime.value) }}</span>
                </div>
              </fcom-checkbox>
            </ng-container>
          </div>
        </div>

        <div *ngIf="showRefundability" class="ms-large ps-large-b">
          <span class="nordic-blue-900-text font-body-1 medium-type">{{
            'flightFilters.refundability.title' | finLocalization
          }}</span>
          <fin-input-radio
            *ngFor="
              let option of [
                { label: 'anyTicketType', value: false },
                { label: 'onlyRefundable', value: true }
              ]
            "
            [name]="option.label"
            (radioChange)="onSelectRefundability(option.value)"
            [value]="option.label"
            [selected]="selectedRefundabilityOption === option.value"
            [label]="'flightFilters.refundability.' + option.label | finLocalization"
          >
          </fin-input-radio>
        </div>
      </ng-container>
    </fcom-filters>
  </ng-container>
</ng-container>
